import {Layout} from "../../component/layout/Layout";
import moebelschluessel from "../../img/price-list-examples/Mobelschuessel.jpg"
import bartschlussel from "../../img/price-list-examples/Bartschluessel.jpg"
import zackenschluessel from "../../img/price-list-examples/zacken_ohne_bohrung.jpg"
import wohnungsschluessel from "../../img/price-list-examples/wohnung_ohne_schutz.jpg"
import wohnungsschluesselMitSchutz from "../../img/price-list-examples/wohnung_mit_schutz.jpg"
import bohrungMitSchutz from "../../img/price-list-examples/bohrung_mit_schutz.jpg"
import bohrungOhneSchutz from "../../img/price-list-examples/bohrung_ohne_schutz.jpg"
import bahnschluessel from "../../img/price-list-examples/bahnschluessel.png"

export const GuestRequestPriceList = ({}) => {

    return (<>
        <Layout username={null}>
            <div className="guest-request-price-list">
                <h1>Was kostet ein Nachschlüssel?</h1>
                <p>Das hängt vom System ab. Die Preise liegen zwischen 6 € und 90 €</p>
                <div className="default">
                    <div className="price-info offer">
                        <div className="title">
                            <h2>Wohnungs- und Haustürschlüssel mit Zacken <strong>ohne</strong> Schlüsselschutz</h2>
                            <div>
                                <p className="price">49 €<br/><span className="offer-highlight">Angebot</span></p>
                            </div>
                        </div>
                        <img src={wohnungsschluessel}/>
                        <p>auch Zentralschlüssel für mehrere Türen<br/>z.B. (steht am Schlüssel) EVVA DPI, DPS, DPX, GPI
                            | Winkhaus VS | GEGE AP2000, AP3, ANS2 </p>
                    </div>
                    <div className="price-info">
                        <div className="title">
                            <h2>Einfache Zylinderschlüssel mit Zacken</h2>
                            <p className="price">ca. 15 €</p>
                        </div>
                        <img src={zackenschluessel}></img>
                        <p>auch kleine Schlüssel für E-Bike, Fahrradschloss, Hängschlos, Briefkasten, Büroschrank,
                            ...</p>
                    </div>
                    <div className="price-info">
                        <div className="title">
                            <h2>Möbelschlüssel</h2>

                            <p className="price">ca. 5 €</p>
                        </div>
                        <img src={moebelschluessel}/>
                    </div>
                    <div className="price-info">
                        <div className="title">
                            <h2>Zimmerschlüssel</h2>

                            <p className="price">ca. 7 €</p>
                        </div>
                        <img src={bartschlussel}/>
                    </div>
                    <div className="price-info">
                        <div className="title">
                            <h2>Wohnungs- und Haustürschlüssel mit Zacken <strong>mit</strong> Schlüsselschutz</h2>
                            <p className="price">ca. 60 €</p>
                        </div>
                        <img src={wohnungsschluesselMitSchutz}/>
                        <p>z.B. (steht am Schlüssel) EVVA EPS | Winkhaus RPS | GEGE Pextra</p>
                    </div>
                    <div className="price-info">
                        <div className="title">
                            <h2>Schlüssel mit Bohrungen <strong>ohne</strong> Schlüsselschutz</h2>
                            <p className="price"> ca. 60 €</p>
                        </div>
                        <img src={bohrungOhneSchutz}/>
                        <p>z.B. (steht am Schlüssel) KABA Gemini S/T, Quattro S | DOM ix6SR, iX5 | KESO 2000, 4000</p>
                    </div>
                    <div className="price-info">
                        <div className="title">
                            <h2>Schlüssel mit Bohrungen <strong>mit</strong> Schlüsselschutz </h2>
                            <p className="price">ca. 60 €</p>
                        </div>
                        <img src={bohrungMitSchutz}/>
                        <p>z.B. (steht am Schlüssel) KABA penta | DOM Teco | KESO 8000 </p>
                    </div>
                    <div className="price-info">
                        <div className="title">
                            <h2>Schlüssel mit Bahnen oder Magneten</h2>
                            <p className="price">ca. 60 €</p>
                        </div>
                        <img src={bahnschluessel}/>
                        <p>z.B. (steht am Schlüssel) EVVA 3KS, 4KS, MCS</p>
                    </div>
                </div>
            </div>
        </Layout>
    </>)
}